import type { CrbtLibraryItem, Track } from "../types";

export function normalizeAtomMsisdn(value: string) {
  const digits = value.replace(/\D/g, "");
  if (digits.startsWith("959")) return `0${digits.slice(2)}`.slice(0, 11);
  if (digits.startsWith("97") && digits.length === 10) return `0${digits}`.slice(0, 11);
  return digits.slice(0, 11);
}

export function isValidAtomMsisdn(value: string) {
  return /^097\d{8}$/.test(normalizeAtomMsisdn(value));
}

export function hasCrbtSubscription(data: unknown) {
  if (!data || typeof data !== "object") return false;
  const object = data as Record<string, unknown>;
  if (typeof object.has_crbt_subscription === "boolean") return object.has_crbt_subscription;
  if (typeof object.subscribed === "boolean") return object.subscribed;
  if (Array.isArray(data)) return data.length > 0;
  if (Array.isArray(object.results)) return object.results.length > 0;
  return false;
}

export function crbtTransactionId(data: Record<string, unknown>) {
  return String(data.clientTransactionId || data.client_transaction_id || data.transaction_id || "");
}

export function crbtToTrack(item: CrbtLibraryItem): Track;
export function crbtToTrack(item: CrbtLibraryItem, overrides: Partial<Track>): Track;
export function crbtToTrack(item: CrbtLibraryItem, overrides?: any): Track {
  const extra = typeof overrides === "object" && overrides !== null ? overrides : {};
  return {
    id: item.id,
    title: item.title,
    artist: item.artist || { id: 0, name: "Unknown artist", image: null, follower_count: 0 },
    thumbnail: item.thumbnail,
    audio_url: item.url || item.audio_file_path,
    duration: item.duration,
    is_premium: false,
    ignore_limit: true,
    ...extra,
  };
}
